import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

const getDeprecateFeatureMapping = (
  t: TFunction
): Record<
  string,
  {
    moduleName: string;
    helpCenterUrl: string;
    redirectUrl: string;
  }
> => {
  return {
    channel: {
      moduleName: t("deprecation.moduleName.channelManagement"),
      helpCenterUrl: "https://help.sleekflow.io/en_US/channels",
      redirectUrl: `https://${process.env.REACT_APP_V2_PATH}/en/channels/whatsapp/account`,
    },
    liveChatWidget: {
      moduleName: t("deprecation.moduleName.liveChatWidget", {
        defaultValue: "Live Chat Widget",
      }),
      helpCenterUrl: "https://help.sleekflow.io/en_US/live-chat-widget",
      redirectUrl: `https://${process.env.REACT_APP_V2_PATH}/en/channels/live-chat-widget`,
    },
    whatsappBackupChats: {
      moduleName: t("deprecation.moduleName.channelManagement"),
      helpCenterUrl: "https://help.sleekflow.io/en_US/channels",
      redirectUrl: `https://${process.env.REACT_APP_V2_PATH}/en/channels/whatsapp/account`,
    },
    hubspot: {
      moduleName: t("deprecation.moduleName.hubspot", {
        defaultValue: "Hubspot",
      }),
      helpCenterUrl:
        "https://help.sleekflow.io/integrations/hubspot-integration",
      redirectUrl: `https://${process.env.REACT_APP_V2_PATH}/en/integrations`,
    },
    labelsManagement: {
      moduleName: t("deprecation.moduleName.labelsManagement", {
        defaultValue: "Labels Management",
      }),
      helpCenterUrl:
        "https://help.sleekflow.io/general-settings/label-management",
      redirectUrl: `https://${process.env.REACT_APP_V2_PATH}/settings/labels`,
    },
    userManagement: {
      moduleName: t("deprecation.moduleName.userManagement", {
        defaultValue: "User Management",
      }),
      helpCenterUrl: "https://help.sleekflow.io/en_US/general-settings",
      redirectUrl: `https://${process.env.REACT_APP_V2_PATH}/settings/user-management`,
    },
    teamManagement: {
      moduleName: t("deprecation.moduleName.teamManagement", {
        defaultValue: "Team Management",
      }),
      helpCenterUrl: "https://help.sleekflow.io/en_US/general-settings",
      redirectUrl: `https://${process.env.REACT_APP_V2_PATH}/settings/team-management`,
    },
  };
};

const useDeprecateFeatureMapping = () => {
  const { t } = useTranslation();
  return useMemo(() => getDeprecateFeatureMapping(t), [t]);
};

export default useDeprecateFeatureMapping;
